import ReactDOM from 'react-dom'

import Select from './Select'
import * as selectModels from './select.model'
import * as selectSelectors from './select.selector'
import * as selectHelpers from './select.helper'
import { constants } from './select.constant'
import { SelectData } from './select.model'

const SelectComponent = (() => {
	const renderSelect = (renderTarget: HTMLElement, target: HTMLSelectElement, label: string) => {
		ReactDOM.render(
			<Select
				data={selectHelpers.getDataFromNativeSelect(target)}
				defaultValue={selectHelpers.getDefaultValueFromNativeSelect(target)}
				id={target.getAttribute('id') || ''}
				label={label}
				onChange={handleSelectChange}
				disabled={target.disabled}
				freeSolo={target.hasAttribute(constants.attribute.freeSolo) || undefined}
				allOption={target.getAttribute(constants.attribute.allOption) || undefined}
				noOption={target.getAttribute(constants.attribute.noOption) || undefined}
				noneOption={target.getAttribute(constants.attribute.noneOption) || undefined}
				placeholder={target.getAttribute(constants.attribute.placeholder) || undefined}
				multiple={target.multiple}
			/>,
			renderTarget,
		)
	}

	const multiselectValueForNativeSelect = (item: selectModels.SelectData) => (item ? item.value : '')

	const getValuesArray = (value: selectModels.SelectData | selectModels.SelectData[]) =>
		(Array.isArray(value) ? value : [value]).map((item) => item.value)

	const handleSelectChange = (id: string, value: selectModels.SelectData | selectModels.SelectData[]) => {
		const input = document.getElementById(id) as HTMLSelectElement
		if (!input) {
			return
		}

		const valuesArray = getValuesArray(value)

		input.value = input.multiple
			? multiselectValueForNativeSelect((value as selectModels.SelectData[])[0])
			: (value as selectModels.SelectData).value

		const options = input.querySelectorAll('option')

		options.forEach((option) => {
			option.selected = false
		})
		selectSelectors.getDynamicOptions(input).forEach((option) => option.remove())

		const selected = Array.from(options).filter((option) => valuesArray.indexOf(option.value) > -1)

		if (input.getAttribute(constants.attribute.freeSolo) === null) {
			selected.forEach((option) => {
				option.selected = true
			})
		} else if (input.multiple) {
			;(value as SelectData[]).forEach((item) => setDynamicOption(input, item))
		} else {
			setDynamicOption(input, value as SelectData)
		}

		const changeEvent = new window.CustomEvent('change')
		input.dispatchEvent(changeEvent)
	}

	const setDynamicOption = (target: HTMLSelectElement, value: SelectData) => {
		let option = selectSelectors.getDynamicOptionWithValue(value.value, target)

		if (option === undefined) {
			option = document.createElement('option')
			option.setAttribute(constants.selector.dynamicOptionAttribute, '')

			option = target.appendChild(option)
		}

		option.value = value.value
		option.text = value.label

		option.selected = true
	}

	const createElementForRender = () => {
		const fragment = document.createDocumentFragment()
		const div = document.createElement('div')
		div.setAttribute(constants.selector.render, '')
		fragment.append(div)
		return {
			fragment,
			div,
		}
	}

	const initSelect = (target: HTMLSelectElement) => {
		const parent = target.parentNode as HTMLElement
		const id = target.getAttribute('id')
		if (!parent || !id) {
			return
		}

		const { fragment, div } = createElementForRender()
		const label = selectSelectors.getLabel(parent)

		const render = selectSelectors.getRender(parent)
		if (render) {
			renderSelect(render, target, label?.textContent || '')
			return
		}

		parent.appendChild(fragment)
		renderSelect(div, target, label?.textContent || '')

		if (label !== null) {
			label.hidden = true
		}
	}
	const initSelects = () => {
		const targets = selectSelectors.getTargets()
		for (let i = 0, { length } = targets; i < length; i++) {
			initSelect(targets[i])
		}
	}

	const init = () => {
		initSelects()
	}

	return {
		init,
		initSelect,
	}
})()

export default SelectComponent
